import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const warnings: Array<{ key: string; message: string }> = [];

  // Validate input data
  if (!properties.inputData) {
    warnings.push({ key: 'inputData', message: 'Input data is empty. Ensure upstream node provides an array.' });
  }

  // Validate user prompt template
  if (!properties.userPromptTemplate || properties.userPromptTemplate.trim() === '') {
    errors.push({ key: 'userPromptTemplate', message: 'User prompt template is required' });
  }

  // Validate system prompt length
  if (properties.systemPrompt && properties.systemPrompt.length > 10000) {
    warnings.push({ key: 'systemPrompt', message: 'System prompt is very long and may affect batch processing' });
  }

  // Validate max tokens
  if (properties.maxTokens !== undefined) {
    if (properties.maxTokens < 100) {
      errors.push({ key: 'maxTokens', message: 'Max tokens must be at least 100' });
    }
    if (properties.maxTokens > 200000) {
      errors.push({ key: 'maxTokens', message: 'Max tokens cannot exceed 200,000' });
    }
  }

  // Validate temperature
  if (properties.temperature !== undefined) {
    if (properties.temperature < 0 || properties.temperature > 2) {
      errors.push({ key: 'temperature', message: 'Temperature must be between 0 and 2' });
    }
  }

  // Validate test mode
  const validTestModes = ['full', 'preview', 'dryrun', 'sample'];
  if (properties.testMode && !validTestModes.includes(properties.testMode)) {
    errors.push({ key: 'testMode', message: 'Invalid test mode selected' });
  }

  // Warn about full batch mode
  if (properties.testMode === 'full') {
    warnings.push({
      key: 'testMode',
      message: 'Full batch mode will suspend the workflow until the batch completes (can take hours for large batches)'
    });
  }

  return {
    valid: errors.length === 0,
    errors,
    warnings
  };
}
